import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import { AvatarWrapStyled } from 'components/Avatar/Avatar.styled';
import FlexContainer from 'components/FlexContainer/FlexContainer';

export const HeaderStyled = styled(FlexContainer)`
  width: 100%;
  padding: 1.5rem;
  gap: 1rem;
  background: ${({ theme }): string => theme.colors.primary.variant1};
  box-shadow: ${({ theme }): string => theme.shadows.variant1};
`;

export const LinkStyled = styled(Link)`
  img {
    transition: filter 0.3s;
  }
  &:hover img {
    filter: ${({ theme }): string => theme.filters.whiteToViolet};
  }
`;
export const MainContainerStyled = styled.section`
  max-width: 1080px;
  margin: 0 auto;
  background: ${({ theme }): string => theme.colors.surface};
  padding: 2rem;
  padding-top: calc(2rem + 64px); /* Account for fixed header (no tabs on profile page) */
  min-height: 100vh;

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      padding: 4rem;
      padding-top: calc(4rem + 64px); /* Account for fixed header (no tabs on profile page) */
    }
  `}

  ${AvatarWrapStyled} {
    margin-top: 2rem;
  }
`;
